<div class="session-expired-overlay">
  <div class="session-expired-card">
    <div class="session-expired-card__illustration">
      <img src="assets/images/session-expired.png" alt="Session expired" />
    </div>

    <div class="session-expired-card__content">
      <h1 class="session-expired-card__title">Your session has expired.</h1>
      <p class="session-expired-card__description">
        Privacy is essential and you've been gone for a while. Please login again to continue working on Content Studio.
      </p>
    </div>

    <div class="session-expired-card__actions">
      <button
        mwc-button
        mwcType="primary"
        mwcShape="round"
        mwcSize="medium"
        (click)="login()"
        class="session-expired-card__btn"
        aria-label="Login page"
        style="padding: 4px 24px;font-weight: 400;">
        Login
      </button>
    </div>
  </div>
</div>
